import { render, staticRenderFns } from "./RelayDetail.vue?vue&type=template&id=48569832&scoped=true"
import script from "./RelayDetail.vue?vue&type=script&lang=js"
export * from "./RelayDetail.vue?vue&type=script&lang=js"
import style0 from "./RelayDetail.vue?vue&type=style&index=0&id=48569832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48569832",
  null
  
)

export default component.exports